import {Component, Input, OnInit} from '@angular/core';
import {Contact} from "../../model/contact";
import {ModalsService} from "../../services/modals.service";
import {SubscriberMelody} from "../../model/subscriber-melody";
import {SubscriberService} from "../../services/subscriber.service";

@Component({
  selector: '[app-contact-item]',
  templateUrl: './contact-item.component.html',
  styleUrls: ['./contact-item.component.css']
})
export class ContactItemComponent implements OnInit {
  @Input() showControls: boolean;
  private _contact: Contact;
  label: string;
  melodies: ReadonlyArray<SubscriberMelody>
  isLoading: boolean = true;
  isNotDonator: boolean = false;

  constructor(private readonly modalsService: ModalsService,
              private readonly subscriberService: SubscriberService) {
    this.melodies = [];
  }

  @Input() set contact(value: Contact) {
    this._contact = value;

    if (value) {
      this.label = value.title.split(' ', 2).map(item => item[0]).join('').toUpperCase();
    }
  }

  get contact(): Contact {
    return this._contact;
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.subscriberService.loadSubscriberMelodies().subscribe({
      next: (melodies) => {
        this.melodies = melodies;
        this.isNotDonator = this.isNotMsisdnDonator(this.contact);
        this.isLoading = false;
      },
      error: (error) => {
        console.error(error);
        this.isNotDonator = false;
        this.isLoading = false;
      }
    });
  }

  isNotMsisdnDonator(contact: Contact): boolean {
    if (!contact.msisdn || !this.melodies || this.melodies.length === 0) {
      return true;
    }

    return !this.melodies.some((melody: SubscriberMelody) =>
        melody.msisdnDonator === contact.msisdn && melody.tariffType === 'PROMO'
    );
  }

  info(): void {
    this.modalsService.showContactInfo(this.contact);
  }
}
